<template v-if="!isCountdownExpired">
  <div class="count-down text-center w-100" :class="{'count-down--expired' : isCountdownExpired}" v-if="countDownDate">
    <div class="header">COUNTDOWN</div>
    <div class="title">{{header}}</div>
    <div class="row align-items-center justify-content-center no-gutters count-number mx-auto">
      <div class="d-inline-block">
        <div class="block mx-auto">
          <div class="digit text-center">{{ days | two_digits(compareDate) }}</div>
          <div class="text text-center">DAYS</div>
        </div>
      </div>
      <div class="d-inline-block">
        <div class="block mx-auto">
          <div class="digit text-center">{{ hours | two_digits(compareDate) }}</div>
          <div class="text text-center">HOURS</div>
        </div>
      </div>
      <div class="d-inline-block">
        <div class="block mx-auto">
          <div class="digit text-center">{{ minutes | two_digits(compareDate) }}</div>
          <div class="text text-center">MINUTES</div>
        </div>
      </div>
      <div class="d-inline-block">
        <div class="block mx-auto">
          <div class="digit text-center">{{ seconds | two_digits(compareDate) }}</div>
          <div class="text text-center">SECONDS</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import get from 'lodash/get'

import getTime from 'date-fns/get_time'
import format from 'date-fns/format'
import differenceInSeconds from 'date-fns/difference_in_seconds'
import differenceInMinutes from 'date-fns/difference_in_minutes'
import differenceInHours from 'date-fns/difference_in_hours'
import differenceInDays from 'date-fns/difference_in_days'
import isAfter from 'date-fns/is_after'

import NodeLink from 'components/node/Link'

export default {
  name: 'widget-count-down',
  components: {
    NodeLink,
  },
  mounted() {
    this.intervalID = window.setInterval(() => {
      this.now = new Date()
    }, 1000)
  },
  props: {
    countDown: {
      type: Object,
      default: () => ({}),
      required: true,
    },
    product: {
      type: Object,
      default: () => ({}),
      required: false,
    },
  },
  data() {
    return {
      now: new Date(),
      intervalID: -1,
    }
  },
  computed: {
    header() {
      return get(this, 'countDown.header', ' ')
    },
    countDownDate() {
      return get(this, 'countDown.countDate', false)
    },
    compareDate() {
      if (this.countDownDate) {
        const passDate = new Date(this.countDownDate)
        const now = new Date()
        return now < passDate
      }
      return false
    },
    date() {
      if (this.countDownDate) {
        return getTime(this.countDownDate)
      }
      return false
    },
    seconds() {
      return differenceInSeconds(this.countDownDate, this.now) % 60
    },
    minutes() {
      return differenceInMinutes(this.countDownDate, this.now) % 60
    },
    hours() {
      return differenceInHours(this.countDownDate, this.now) % 24
    },
    days() {
      return differenceInDays(this.countDownDate, this.now)
    },
    isCountdownExpired() {
      if (this.compareDate && isAfter(this.countDownDate, this.now)) {
        return false
      }
      return true
    },
    productRelatedReviewArticleNode() {
      // Update the logic here once the api call has been created to get the related review article for the product in the comparison page
      const ishidden = false
      return ishidden
    },
  },
  filters: {
    two_digits: (value, compare) => {
      if (!compare) {
        return '00'
      }
      if (value.toString().length <= 1) {
        return `0${value.toString()}`
      }
      return value.toString()
    },
    date_format_to: (value, dateFnsToken) => {
      const formatted = format(new Date(value), dateFnsToken)
      return formatted
    },
  },
  destroyed() {
    if (this.destroyed !== -1) {
      clearInterval(this.intervalID)
    }
  },
}

</script>
<style lang="scss" scoped>
.count-down {
  -webkit-font-smoothing: antialiased;
  font-family: $barlow;
  line-height: 1;
  color: $rose;
  background: $waterspout;

  min-height: rem-calc(128);
  max-width: rem-calc(375);

  padding: rem-calc(16 19 20 19);
  margin-left: auto;
  margin-right: auto;

  .header {
    font-size: rem-calc(16);
    color: $rose;
    font-weight: bold;
    line-height: rem-calc(19);
    margin-bottom: rem-calc(4);
  }
  .title {
    margin-bottom: rem-calc(10);
    color: $black;
    font-family: $bungee;
    font-size: rem-calc(28);
    line-height: rem-calc(28);
  }
  .count-number {
    .block {
      width: rem-calc(50);
      .text {
        font-size: rem-calc(8);
        font-weight: bold;
        line-height: rem-calc(10);
      }
      .digit {
        font-size: rem-calc(22);
        line-height: rem-calc(26);
        margin-bottom: rem-calc(2);
      }
    }
  }
  .product-review-btn {
    cursor: pointer;
    font-size: rem-calc(18);
    line-height: rem-calc(22);
    text-transform: uppercase;
    color: $white;
    display: inline-block;
    background-color: $rose;
    margin-top: rem-calc(11);
    padding: rem-calc(10 10);
    width: 100%;
    max-width: rem-calc(321);
    &:hover, &:focus, &:active {
      color: $white;
    }
  }
  &--expired {
    .title {
      margin-bottom: rem-calc(8);
    }
    .expired {
      &__text {
        font-size: rem-calc(20);
        line-height: rem-calc(24);
      }
      &__date {
        font-size: rem-calc(24);
        line-height: rem-calc(29);
      }
    }
  }

  .isCountdownCard & {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,0.7);
    color: $rose;
    z-index: 1;
    max-width: none;
    padding: rem-calc(20 5 70);

    @include respond-to('mobile') {
      z-index: 10;
    }

    @include respond-to('desktop_or_landscape') {
      padding: rem-calc(20 0 27 0);
      font-size: rem-calc(28);
    }

    > .header {
      font-size: rem-calc(16);
      line-height: rem-calc(15);
      margin-bottom: rem-calc(6);

      @include respond-to('desktop_or_landscape') {
        font-size: rem-calc(28px);
        line-height: rem-calc(23px);
        margin-bottom: rem-calc(10);
      }
      color: $white;
    }

    > .title {
      display: none;
    }

    > .product-review-btn {
      display: none;
    }

    .count-number {
      .block {
        @include respond-to('desktop_or_landscape') {
          width: rem-calc(64);
          margin-bottom: rem-calc(2);
        }
        .text {
          font-size: rem-calc(8);
          line-height: rem-calc(9);
          margin-bottom: rem-calc(2);

          @include respond-to('desktop_or_landscape') {
            font-size: rem-calc(12);
            line-height: rem-calc(14);
            height: auto;
          }
          font-weight: bold;
        }
        .digit {
          @include respond-to('desktop_or_landscape') {
            font-size: rem-calc(34);
            line-height: rem-calc(40);
            height: auto;
            margin-bottom: rem-calc(4);
          }
        }
      }
    }

    &--expired {
      display: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// CountDown.vue?32ddbec2